import './PageBreadcrumb.css';

function PageBreadcrumb({ current }) {
  if (!current) {
    return null;
  }

  return (
    <nav className="page-breadcrumb" aria-label="Breadcrumb">
      <span className="page-breadcrumb__item">Home</span>
      <span className="page-breadcrumb__separator" aria-hidden="true">
        /
      </span>
      <span className="page-breadcrumb__item page-breadcrumb__item--current">{current}</span>
    </nav>
  );
}

export default PageBreadcrumb;
